import React, { useState } from 'react';
import { Label, TextInput, Button, Flowbite, Datepicker, FileInput, Modal } from 'flowbite-react';
import {buttonTheme, centerText, datePickerTheme} from '../components/themes.js'
import Footer  from '../components/Footer';
import { cancelRide } from '../firebase/FirebaseManagement.js';
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router';
import { Store } from 'react-notifications-component';
export default function CancelRide() { 
    const {rideId} = useParams()
    const [openModal, setOpenModal] = useState();
    const props = { openModal, setOpenModal };
    const navigate = useNavigate();

    const handleCancelRide = async (e) => { 
        e.preventDefault();
        try {
            const res = await cancelRide(rideId)

            if (res) {
                Store.addNotification({
                  title: "RexRide Cancelled",
                  message: "Your RexRide has been cancelled.",
                  type: "success",
                  insert: "top",
                  container: "top-right",
                  animationIn: ["animate__animated", "animate__fadeIn"],
                  animationOut: ["animate__animated", "animate__fadeOut"],
                  dismiss: {
                    duration: 5000,
                    showIcon: true
                  }
                });
                navigate("/myrides")
            }

        }catch (error) {
            // ShowAlerts
        }



    }

    return (
    
        <div className="flex flex-col gap-[20px] box-container">
        <h1 className="text-3xl font-bold">Cancel my Rex Ride</h1>
        
        <form  className='flex flex-col gap-[20px]'>

        <Flowbite >

            <Label className='mt-3'>Reason   for Cancellation</Label>
            <TextInput className='w-full' placeholder='Reason for Cancellation' />
        </Flowbite>
        

        <Flowbite theme={{ theme: buttonTheme }} >
            <Button color="primary" className='w-full mt-3' onClick={()=>props.setOpenModal('dismissible')}>Cancel RexRide</Button>

            </Flowbite>
            <Modal dismissible show={props.openModal === 'dismissible'} onClose={() => props.setOpenModal(undefined)}>
        <Modal.Header>Confirm Cancel</Modal.Header>
        <Modal.Body>
          <div className="space-y-6">

            <p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
              Are you sure you want to cancel your Rex Ride?
            </p>
          </div>
          <Flowbite theme={{ theme: buttonTheme }} >
            <Button color="primary" className='w-full mt-3' onClick={(e)=>{handleCancelRide(e)}}>Yes! Cancel Rex Ride</Button>

            </Flowbite>
        </Modal.Body>
      </Modal>
        
        </form>
        <Footer/>
        </div>
    )
            

}